<template>
  <inventoryProductsCategoriesList/>
</template>
<script>
import inventoryProductsCategoriesList from '@/components/modules/restaurant/products/categories/list'
export default {
  name: 'inventoryCategories',
  components: {
    inventoryProductsCategoriesList
  }
}
</script>



// WEBPACK FOOTER //
// src/views/restaurant/products/categories/list.vue